import { useState } from 'react'
import { PersonSelect } from '@/components/PersonSelect'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import type { Tree } from '@/lib/tree'
import { AddConnection } from './AddConnection'

// "Add a person", from the People page's "+": the same family connection a card offers, starting from whoever the page
// is about (you, or the person the tree is on), and anyone else can be picked instead.
export function AddPerson({
  open,
  onOpenChange,
  familyId,
  tree,
  from,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  familyId: string
  tree: Tree
  from: string
}) {
  const [ofId, setOf] = useState(from)
  const of = tree.people.find((p) => p.id === ofId) ?? tree.people.find((p) => p.id === from) ?? tree.people[0]
  const everyone = [...tree.people].sort((a, b) => a.name.localeCompare(b.name))
  if (!of) return null
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90svh] overflow-y-auto sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Add a person</DialogTitle>
          <DialogDescription>Pick who they’re family to, then how.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          <Label htmlFor="add-person-of">Family to</Label>
          <PersonSelect
            id="add-person-of"
            placeholder="Pick someone"
            people={everyone}
            value={of.id}
            onChange={setOf}
          />
        </div>
        <AddConnection key={of.id} familyId={familyId} of={of} tree={tree} onDone={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  )
}
